module.exports = __webpack_public_path__ + "img/PCAD_DiscountCode_Website.9c482049.jpg";